"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "devices", {
  enumerable: true,
  get: function get() {
    return _devices.devices;
  }
});
var _devices = require("./libs/devices");